var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"val",style:('width: ' + _vm.progressVal + '%')})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }